module.exports = __webpack_public_path__ + "static/media/coffeecup.86ed95f4.svg";